module.exports = __webpack_public_path__ + "static/img/weather_015.4984c601.svg";